(() => {
  'use strict';
  const dialog = document.querySelector('[data-store-regions]');
  if (!dialog || !dialog.showModal) return;
  const entryParameter = 'choose-store';
  const entryPendingKey = 'sothing-region-entry-pending';
  const entryUrl = new URL(location.href);
  let shouldOpen = entryUrl.searchParams.get(entryParameter) === '1';
  if (shouldOpen) {
    try { sessionStorage.setItem(entryPendingKey, '1'); } catch {}
    entryUrl.searchParams.delete(entryParameter);
    history.replaceState(history.state, '', entryUrl.pathname + entryUrl.search + entryUrl.hash);
  } else {
    try { shouldOpen = sessionStorage.getItem(entryPendingKey) === '1'; } catch {}
  }
  const languageMenu = document.querySelector('[data-header-language-menu]');
  const languageToggle = languageMenu?.querySelector('[data-language-toggle]');
  const languagePopover = languageMenu?.querySelector('[data-language-popover]');
  const languageOptions = [...(languageMenu?.querySelectorAll('[role="option"]') || [])];
  const closeLanguages = (restoreFocus = false) => {
    if (!languagePopover) return;
    languagePopover.hidden = true;
    languageToggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) languageToggle.focus();
  };
  const openLanguages = (focusOption = false) => {
    languagePopover.hidden = false;
    languageToggle.setAttribute('aria-expanded', 'true');
    if (focusOption) (languageOptions.find(option => option.getAttribute('aria-selected') === 'true') || languageOptions[0])?.focus();
  };
  languageToggle?.addEventListener('click', () => {
    if (languagePopover.hidden) openLanguages(); else closeLanguages();
  });
  languageToggle?.addEventListener('keydown', event => {
    if (['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); event.stopPropagation(); openLanguages(true); }
  });
  languageMenu?.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeLanguages(true); return; }
    const index = languageOptions.indexOf(document.activeElement);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowDown') next = (index + 1) % languageOptions.length;
    if (event.key === 'ArrowUp') next = (index + languageOptions.length - 1) % languageOptions.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = languageOptions.length - 1;
    if (next !== undefined) { event.preventDefault(); languageOptions[next].focus(); }
  });
  languageMenu?.addEventListener('focusout', event => {
    if (event.relatedTarget && !languageMenu.contains(event.relatedTarget)) closeLanguages();
  });
  document.addEventListener('pointerdown', event => {
    if (languageMenu && !languageMenu.contains(event.target)) closeLanguages();
  });
  let opener;
  const open = trigger => {
    opener = trigger;
    closeLanguages();
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('#sr-title').focus();
    dialog.querySelector('.sr-body').scrollTop = 0;
  };
  document.querySelectorAll('[data-region-open]').forEach(button => button.addEventListener('click', () => open(button)));
  dialog.querySelector('[data-region-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.querySelectorAll('[data-region-direct]').forEach(link => link.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = document.getElementById(link.dataset.localizationForm);
    if (!form) return;
    event.preventDefault();
    form.requestSubmit();
  }));
  const forms = [...dialog.querySelectorAll('form'), ...document.querySelectorAll('.sr-language-form')];
  forms.forEach(form => {
    const synchronizeReturnTo = () => form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = location.pathname + location.search + location.hash; });
    synchronizeReturnTo();
    form.addEventListener('submit', event => {
      synchronizeReturnTo();
      try { sessionStorage.removeItem(entryPendingKey); } catch {}
      const language = event.submitter?.value || form.querySelector('[name="language_code"]')?.value;
      const country = form.querySelector('[name="country_code"]')?.value;
      if (country === document.body.dataset.storeCountry && language === document.documentElement.lang) {
        event.preventDefault();
        dialog.close();
        closeLanguages(true);
      }
    });
  });
  if (shouldOpen) { try { sessionStorage.removeItem(entryPendingKey); } catch {} open(); }
})();
